import React from "react";
import {
  useDeleteVideoMutation,
  useGetVideosQuery,
} from "../../../features/Admin/Videos/videosApi";
import Table from "../../../components/Table/Table";
import TableOuterLabel from "../../../components/Table/TableOuterLabel";
import VideosListTr from "./VideosListTr";
import Loading from "../../../components/Ui/Loading";
import Error from "../../../components/Ui/Error";

const headers = ["Video Title", "Description", "Action"];

export default function Videos() {
  const [deleteVideo, { isError: deleteVdoIsError }] = useDeleteVideoMutation();
  const { data: videos, isLoading, isError } = useGetVideosQuery();

  const handleDeleteVideo = (vId) => {
    deleteVideo(vId);
  };

  // Decided which part render
  let content = null;
  let contentLoadingOrError = null;
  if (isLoading) {
    contentLoadingOrError = <Loading />;
  } else if (!isLoading && (isError || deleteVdoIsError)) {
    contentLoadingOrError = (
      <Error
        header="Error !!"
        message="System error contact with administrator"
      />
    );
  } else if (!isLoading && !isError && videos?.length === 0) {
    contentLoadingOrError = <Error header="" message="No video available" />;
  } else if (!isLoading && !isError && videos?.length > 0) {
    content = videos.map((row, index) => (
      <VideosListTr
        row={row}
        key={`${row?.id}_${index}`}
        handleDeleteVideo={handleDeleteVideo}
      />
    ));
  }
  content = contentLoadingOrError ? (
    contentLoadingOrError
  ) : (
    <Table headers={headers}>{content}</Table>
  );

  return (
    <>
      <TableOuterLabel to={"/admin/addVideo"} btnText={"Add Video"} />
      <div className="overflow-x-auto mt-4">{content}</div>
    </>
  );
}
